<template>
  <div class="content">
    <div class="container-fluid">
      <p>Пользователь {{cards.name}}</p>
      <div class="row">

        <div class="col-xl-4 col-md-4">
          <stats-card>
            <div slot="header" class="icon-warning icon">
              <i class="nc-icon nc-chart text-warning"></i>
            </div>
            <div slot="content">
              <p class="card-title">Баланс</p>
              <h4 class="card-category">{{ cards.balance.amount }}</h4>
              <p class="card-title">Ордера</p>
              <h4 class="card-category">{{ cards.balance.orders }}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-refresh"></i> {{ cards.balance.date }}
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-4">
          <stats-card>
            <div slot="header" class="icon-info icon">
              <i class="nc-icon nc-chart-bar-32 text-info"></i>
            </div>
            <div slot="content">
              <p class="card-title">Сделки</p>
              <h4 class="card-category chart-category">
                {{ cards.dials_all }}
              </h4>
              <h4 class="card-category chart-category">
                <i class="fa fa-check"></i> {{ cards.dials_succes  }}
              </h4>
              <h4 class="card-category chart-category">
                <i class="fa fa-times"></i> {{ cards.dials_fail  }}
              </h4>
            </div>
            <div slot="footer">
              <i class="fa fa-refresh"></i> за 30 дней
            </div>
          </stats-card>
        </div>

        <div class="col-xl-4 col-md-4">
          <stats-card>
            <div slot="header" class="icon-success icon">
              <i class="nc-icon nc-light-3 text-success"></i>
            </div>
            <div slot="content">
              <p class="card-title">Процент</p>
              <h4 class="card-category">{{ cards.percent}}</h4> 
              <p class="card-title">Курс</p>
              <h4 class="card-category">{{ cards.rate}}</h4> 
            </div>
            <div slot="footer">
              <i class="fa fa-refresh"></i>
            </div>
          </stats-card>
        </div>

        <!--<div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-danger icon">
              <i class="nc-icon nc-vector text-danger"></i>
            </div>
            <div slot="content">
              <p class="card-title">Аккаунты</p>
              <h4 class="card-category">{{ cards.accounts }}</h4>
            </div>
            <div slot="footer">
              <i class="fa fa-refresh"></i>Updated now
            </div>
          </stats-card>
        </div>-->

      </div>
      <br>
      <div class="row">
        <div class="col-md-8">
          <chart-card :chart-data="lineChart.data"
                      :chart-options="lineChart.options"
                      :responsive-options="lineChart.responsiveOptions">
            <template slot="header">
              <h4 class="card-title chart-title">Сделки</h4>
              <!--<div class="card-categories">
                <p class="card-category chart-category">
                  Успешны {{ cards.dials_succes  }}
                </p>
                <p class="card-category chart-category">
                  Отменены {{ cards.dials_fail  }}
                </p>
              </div>-->
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Успешны
                <i class="fa fa-circle text-danger"></i> Отменены
              </div>
            </template>
          </chart-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'
  import store from 'src/store.js'
  import api from 'src/api.js'

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    methods: {
      getData() {
        api.get('https://dev.fly7.ru/mb600/hs/dash/info')
        .then(response => {
          console.log(response)
          this.setData(response.data)
          store.commit('setName', response.data.name)
        }).catch(error => {
          console.log(error)
          this.getData()
        })
      },
      setData(data) {
        this.cards.balance = data.balance[0];
        this.cards.percent = data.percent;
        this.cards.accounts = data.accounts;
        this.cards.rate = data.rate;
        this.cards.dials_all =  data.dials_all
        this.cards.dials_succes = data.dials_succes
        this.cards.dials_fail = data.dials_fail
        this.cards.name = data.name

        for(let [index, deal] of data.dials.entries()) {
          this.lineChart.data.series[0][index] = deal.succes
          this.lineChart.data.series[1][index] = deal.fail
          this.lineChart.data.labels[index] = deal.date
        }
      }
    },  
    mounted() {
      this.getData()
    },
    data () {
      return {
        cards: {
          balance: {
            currency: '',
            amount: 0,
            orders: 0,
            date: ''
          },
          rate: 0,
          percent: 0,
          accounts: 0,
          dials_all: 0,
          dials_fail: 0,
          dials_succes: 0,
          name: ''
        },
        lineChart: {
          data: {
            labels: [0],
            series: [
              [0],
              [0],
            ]
          },
          options: {
            low: 0,
            high: 100,
            showArea: false,
            height: '245px',
            width: '2500px',
            axisX: {
              showGrid: true
            },
            lineSmooth: true,
            showLine: true,
            showPoint: true,
            fullWidth: false,
            chartPadding: {
              right: 50
            }
          }
        },
      }
    }
  }
</script>
<style>

</style>
